/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Bump_After_HourInputs */

const cs_portals_bump_after_hour = /** @type {(inputs: Portals_Bump_After_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po hodině`)
};

const en_portals_bump_after_hour = /** @type {(inputs: Portals_Bump_After_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After hour`)
};

/**
* | output |
* | --- |
* | "After hour" |
*
* @param {Portals_Bump_After_HourInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_bump_after_hour = /** @type {((inputs?: Portals_Bump_After_HourInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Bump_After_HourInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_bump_after_hour(inputs)
	return cs_portals_bump_after_hour(inputs)
});